import React from "react";
import {observer} from "mobx-react";
import merchantStoresMenuStore from "../../merchant-portal-menu-list-store";

const Search = observer(() => {
    return (
        <div className="portal-selection__searchwrapper">
            <input
                name="ortal-selection__searchbox"
                className="portal-selection__searchbox"
                autoCapitalize="none"
                autoComplete="off"
                autoCorrect="off"
                spellCheck="false"
                type="text"
                autoFocus={false}
                placeholder="Search store/portal"
                value={merchantStoresMenuStore.searchValue}
                onChange={(e) => {
                    merchantStoresMenuStore.setSearchValue(e.target.value);
                }}
                // Prevent the menu from closing when clicking on the input
                onMouseDown={(e) => {
                    e.stopPropagation();
                }}
                // Backspace button doesn't work without this
                onKeyDown={(e) => {
                    e.stopPropagation();
                }}
            />
        </div>
    )
});

export default Search;